import { render, staticRenderFns } from "./mc-footer.tests.vue?vue&type=template&id=3235f0e7&scoped=true"
import script from "./mc-footer.tests.vue?vue&type=script&lang=ts"
export * from "./mc-footer.tests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3235f0e7",
  null
  
)

export default component.exports